<template>
  <div :data="JSON.stringify(dataInfo())" class="article-item" @click="headleClick">
    <div class="item-left">
      <h5>{{ ariaDetails.title }}</h5>
      <div class="left-img">
        <p v-if="ariaDetails.type === 2">
          <img alt="" src="@/assets/images/powderedMilk/bofang.png">
          <span>{{ ariaDetails.lookNum }}</span>
        </p>
        <p v-if="ariaDetails.type === 1">
          <img alt="" src="@/assets/images/powderedMilk/yanjing.png">
          <span>{{ ariaDetails.lookNum }}</span>
        </p>
        <p>
          <img alt="" src="@/assets/images/powderedMilk/pinglun.png">
          <span>{{ ariaDetails.commentNum }}</span>
        </p>
      </div>
    </div>
    <div class="item-right">
      <p :style="{ backgroundImage: 'url(' + ariaDetails.imgUrl + ')',backgroundPosition: ariaDetails.type === 1?'left top':'right top'}"></p>
      <img v-if="ariaDetails.type === 2" alt="" class="right-bg" src="@/assets/images/powderedMilk/spbof.png">
    </div>

  </div>
</template>
<script>

import {
  BuiedPointClick_Fn,
  Exposurer_classify_Fn,
  Exposurer_essay_Fn,
  Exposurer_milk_Fn,
} from '@/assets/js/BuriedPointEvent'

export default {
  name: 'article-item',
  data() {
    return {}
  },
  props: {
    ariaDetails: {
      type: Object,
      required: true
    },
    index: Number,
    previousStatus: String,
    childName: String,
    getContainer: String
  },
  watch: {
    ariaDetails: {
      handler(newValue) {
        if (newValue.articleId) {
          this.Exposurer()
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    babyBuried() {
      const babyBuried = JSON.parse(localStorage.getItem("babyBuried"));
      return babyBuried ? babyBuried : {};
    }
  },
  mounted() {
    this.Exposurer()
  },
  methods: {
    dataInfo(data = {}) {
      const babyBuried = JSON.parse(localStorage.getItem("babyBuried"));
      const obj = {
        Baby_Month: babyBuried ? babyBuried.name : "",
        content_type: this.ariaDetails.type === 1 ? '奶娃百科' : '京城名医',
        content_id: this.ariaDetails.articleId,
        content_title: this.ariaDetails.title,
        exposure_number: this.index,
        firstclassify_name: this.$route.query.previousTitle,
        secondclassify_name: this.$attrs.childName || this.childName,
      }
      return {...obj, ...data}


    },
    headleClick() {
      console.log(this.ariaDetails, '************')
      if (this.ariaDetails.type == 1) {
        // console.log(this.$route, '$route$route$route')
        BuiedPointClick_Fn('NewsClick', {
          xmhh5_articletitle_view_pagename: this.$route.query.previousTitle || this.$route.meta.title,
          xmhh5_article_title: this.ariaDetails.title
        })
      }
      if (this.$route.query.previousStatus) {
        BuiedPointClick_Fn('milkinfo_classifypage_content_click', this.dataInfo({
          milkinfo_plate: this.$route.query.previousStatus === 'milk' ? "奶粉星球" : "奶粉专题",
          exposure_number: undefined,
          secondclassify_name: undefined
        }))
      } else {
        BuiedPointClick_Fn('milkinfo_home_star_content_click', this.dataInfo({
          exposure_number: undefined,
          firstclassify_name: this.$attrs.parentName
        }))
      }
      this.$emit('headleClick', this.ariaDetails)
    },

    Exposurer() {
      if (this.$route.query.previousStatus) {
        Exposurer_classify_Fn.observe('milkinfo_classifypage_content_expo', '.article-item', false, {
          secondclassify_name: undefined,
        })
      } else {
        Exposurer_milk_Fn.observe('milkinfo_home_star_content_expo', '.article-item', false, {
          firstclassify_name: this.$attrs.parentName,
        })
      }

      setTimeout(() => {
        if (this.ariaDetails.type == 1) {
          Exposurer_essay_Fn.observe('NewsShown', '.article-item', false, {
            xmhh5_articletitle_view_pagename: this.$route.query.previousTitle || this.$route.meta.title,
          })
        }
      }, 100)
    }
  },
}
</script>
<style lang="less" scoped>
.itemBorder {
  border: none !important;
}

.article-item {
  //width: auto;
  flex: 1;
  max-height: 88px;
  //min-height: 88px;
  height: 88px;
  //margin-left: 12px;
  position: relative;
  align-items: center;
  justify-items: center;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid rgba(151, 151, 151, .15);

  .item-left {
    flex: 1;

    h5 {
      width: auto;
      padding-right: 10px;
      height: 30px;
      color: #333;
      line-height: 16px;
      font-size: 13px;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      word-wrap: break-word;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      margin-top: 15px;
    }

    .left-img {
      display: flex;
      margin-bottom: 12px;
      margin-top: 10px;

      p {
        width: 70px;
        color: #888;
        display: flex;

        img {
          width: 18px;
          height: 18px;
          margin-right: 2px;
        }

        span {
          margin-top: 2px;
        }
      }
    }

  }

  .item-right {
    flex-shrink: 0;
    width: 58px;
    height: 58px;
    //margin-right: 8px;
    text-align: center;
    position: relative;
    display: flex;

    p {
      width: 56px;
      height: 56px;
      background-repeat: no-repeat;
      //background-clip: content-box;
      background-size: cover;
      //background-position: center;
      //margin: auto;
      //overflow: hidden; //img如果超出这个div会隐藏超出部分
      //display: flex; //flex布局
      //align-items: center; //让img放在div的中间，居中

      //display: flex;
      //justify-content: center;
      //justify-items: center;
    }

    .right-img {
      width: 100%;
      display: inline;
      object-fit: cover
      //height: 56px;
    }

    .right-bg {
      width: 24px;
      height: 24px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -12px;
      margin-left: -12px;

    }
  }
}


</style>
